import { BaseDataService } from "../../../services/base/BaseDataService";
import { PDFNoteCodeQuery } from "../models/PDFNoteCodeQuery";
import { PDFNoteCode } from "../models/PDFNoteCode";

export class PDFNoteCodeService extends BaseDataService<PDFNoteCode, PDFNoteCodeQuery> {
  protected prefixUrl: string = `PDFNoteCodes`;
}